import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getRepositoryByPID } from "../api/pyxis";
import { IAPIError } from "../interfaces/common";
import { IRepoDetailsResponse } from "../interfaces/repo";

export const repoDetailsQueryKey = ['repoDetails'] as const;

export const useRepoDetails = (url: string, enabled?: boolean):
  UseQueryResult<IRepoDetailsResponse, IAPIError> => {
  return useQuery<IRepoDetailsResponse, IAPIError>({
    queryKey: repoDetailsQueryKey,
    queryFn: ({ signal }) => getRepositoryByPID(url, signal),
    enabled
  });
};
